<div id="popup">
    <div class="title-head index-head" fxLayout="row" fxLayoutAlign="space-between center">
        <span>
            Mapper
        </span>
        <button [attr.guide]="'xlmapper-dialog-btn-1' + '__' + sanitizedUrl" mat-icon-button>
            <mat-icon (click)="close()">
                close
            </mat-icon>
        </button>
    </div>
    <mat-dialog-content [ngStyle.lt-md]="'max-height: 100%'" style=" MARGIN: 0PX; padding: 0px;">
        <div  [formGroup]="firstFormGroup" class="padding-11">

            <div class="title " fxLayout="row" fxLayoutAlign="space-between center">
                <span>Source Mapper</span>
                <button [attr.guide]="'xlmapper-dialog-btn-2' + '__' + sanitizedUrl" class="micon" color="primary" mat-icon-button>
                    <mat-icon (click)="addOption()">
                        add
                    </mat-icon>
                </button>
            </div>

           
            <div>
                <div class="result" fxLayout="column">

                    <div color="warn">
                        <div fxLayout="row wrap" fxFlex="100">
                            <div color="warn" fxFlex="100">
                                <div formArrayName="sourceMapper" *ngFor="let Profileadd of firstFormGroup.get
                                ('sourceMapper')['controls']; let i = index">
                                    <div [formGroupName]="i">

                                        <div class="input-row" fxLayout="row"
                                            fxLayout.sm="column" fxLayout.xs="column"
                                            fxLayoutGap="10px">

                                            <mat-form-field appearance="outline" fxFlex>
                                                <mat-label>Form Fields
                                                    Mapper</mat-label>
                                                <mat-select
                                                    [disableOptionCentering]="true"
                                                    #singleSelect
                                                    formControlName="fieldMapper"
                                                    autocomplete="off">
                                                    <!-- <mat-option>
                                                        <ngx-mat-select-search
                                                            name="Fields search"
                                                            ngDefaultControl
                                                            [formControl]="attributeFilterControl"
                                                            placeholderLabel="Search"
                                                            [preventHomeEndKeyPropagation]="true"
                                                            noEntriesFoundLabel="No data found">
                                                        </ngx-mat-select-search>
                                                    </mat-option> -->
                                                    <mat-option *ngFor="let key of data" [value]="key">
                                                        {{ key }}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>

                                            <mat-form-field appearance="outline" fxFlex>
                                                <mat-label>Form Fields</mat-label>
                                                <mat-select
                                                    [disableOptionCentering]="true"
                                                    #singleSelect
                                                    formControlName="formFields"
                                                    autocomplete="off">
                                                    <mat-option>
                                                        <ngx-mat-select-search
                                                            name="Fields search"
                                                            ngDefaultControl
                                                            [formControl]="attributeFilterControl"
                                                            placeholderLabel="Search"
                                                            [preventHomeEndKeyPropagation]="true"
                                                            noEntriesFoundLabel="No data found">
                                                        </ngx-mat-select-search>
                                                    </mat-option>
                                                    <mat-option
                                                        [disabled]="isFieldAlreadySelected(opt.attributeCode, i)"
                                                        *ngFor="let opt of filteredAttributeTypeList; let optIndex=index;"
                                                        [value]="opt.attributeCode">
                                                        {{opt.frontendLabel}}
                                                    </mat-option>
                                                </mat-select>

                                            </mat-form-field>

                                            <button [attr.guide]="'xlmapper-dialog-btn-3' + '__' + sanitizedUrl" [disabled]="i<1"
                                                fxLayoutAlign="center end"
                                                mat-icon-button color="warn"
                                                (click)="removeOption(i)">
                                                <mat-icon>
                                                    delete
                                                </mat-icon>
                                            </button>

                                        </div>
                                    </div>

                                </div>
                               

                            </div>
                        </div>
                    </div>

                </div>
            </div>


            <div class="padding-top10" fxLayoutAlign="end center" fxLayoutGap="10px">

                <button [attr.guide]="'xlmapper-dialog-btn-4' + '__' + sanitizedUrl" type="button" mat-raised-button (click)="close()">Cancel
                </button>

                <button [attr.guide]="'xlmapper-dialog-btn-5' + '__' + sanitizedUrl" [disabled]="text !='Submit'" (click)="submit()" mat-raised-button>
                    {{text}}
                    <mat-icon *ngIf="text !='Submit' ">
                        <mat-spinner color="primary" diameter="20">
                        </mat-spinner>
                    </mat-icon>
                </button>


            </div>
        </div>
    </mat-dialog-content>
</div>